import { Injectable, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ResolveEnd, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { config, Subscription } from 'rxjs';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter, take } from 'rxjs/operators';


@Injectable()
export class MyMonitoringService {
    appInsights!: ApplicationInsights;
    private routerSubscription!: Subscription;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        // this.configService.getConfig()
        //     .pipe(take(1))
        //     .subscribe((config: Configs) => {
        //         this.appInsights = new ApplicationInsights({
        //             config: {
        //                 instrumentationKey: config.appInsights.instrumentationKey,
        //                 enableAutoRouteTracking: true // option to log all route changes
        //             }
        //         });

        //         this.routerSubscription = this.router.events
        //             .pipe(filter((event: any) => event instanceof ResolveEnd))
        //             .subscribe((event: ResolveEnd) => {
        //                 const activatedComponent = this.getActivatedComponent(event.state.root);
        //                 if (activatedComponent) {
        //                     this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
        //                 }
        //             });

        //         this.appInsights.loadAppInsights();
        //         this.loadCustomTelemetryProperties();
        //         this.createRouterSubscription();
        //     });
    }

    setAuthenticatedUserId(userId: string): void {
        this.appInsights.setAuthenticatedUserContext(userId);
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {

        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }

    logPageView(name?: string, url?: string) { // option to call manually
        this.appInsights.trackPageView({
            name: name,
            uri: url
        });
    }

    logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights.trackEvent({ name: name }, properties);
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights.trackMetric({ name: name, average: average }, properties);
    }

    logException(exception: Error, severityLevel?: number) {
        this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    }

    logTrace(message: string, properties?: { [key: string]: any }) {
        this.appInsights.trackTrace({ message: message }, properties);
    }


    private loadCustomTelemetryProperties() {
        this.appInsights.addTelemetryInitializer(envelope => {
            var item: any = envelope.baseData;
            item.properties = item.properties || {};
            item.properties["ApplicationPlatform"] = "Web";
            item.properties["ApplicationName"] = "ApplicationName";
        });
    }
    private createRouterSubscription() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
            this.logPageView(undefined, event.urlAfterRedirects);
        });
    }
}